










































































































































































































































import {Component, Inject, Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";
import {orderBy} from "lodash";
import season1Teams from "@/data/championship/season1/teams.json";
import season2Teams from "@/data/championship/season2/teams.json";
import season3Teams from "@/data/championship/season3/teams.json";
import season1Calendar from "@/data/championship/season1/calendar.json";
import season2Calendar from "@/data/championship/season2/calendar.json";
import season3Calendar from "@/data/championship/season3/calendar.json";
import season3FinalFour from "@/data/championship/season3/finals.json";
import {MatchmakingService} from "@/services/MatchmakingService";
import {DataService} from "@/services/DataService";
import {ChampionshipMatch, ChampionshipTeam, FinalMatch} from '@/model/Championship';
import Game from "@/model/Game";
import {Player, PlayerGlobalData, PlayerRef} from "@/model/Player";


@Component({
    computed: {
        ...mapGetters({
            games: "games",
            gameResults: "championshipGames"
        })
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (vm.$route.query.s) {
                // @ts-ignore
                vm.seasonKey = vm.$route.query.s;
            }
            // @ts-ignore
            vm.init();
        });
    }
})
export default class Championship extends Vue {
    @Inject("matchMakingService") public matchMakingService!: MatchmakingService;
    @Inject("dataService") public dataService!: DataService;
    protected games!: Game[];
    protected gameResults!: Game[];
    private teams: ChampionshipTeam[] = [];
    private matches: ChampionshipMatch[] = [];
    private finalMatches: FinalMatch[] = [];
    private bestPlayer: {ref: PlayerRef, value: number} = {ref: {} as PlayerRef, value: 0};
    private totalKills: {ref: PlayerRef, value: number} = {ref: {} as PlayerRef, value: 0};
    private killStreak: {ref: PlayerRef, value: number} = {ref: {} as PlayerRef, value: 0};
    private longestKill: {ref: PlayerRef, value: number} = {ref: {} as PlayerRef, value: 0};
    private collateralKill: {ref: PlayerRef, value: number} = {ref: {} as PlayerRef, value: 0};
    private teamKill: {ref: PlayerRef, value: number} = {ref: {} as PlayerRef, value: 0};
    private defuser: {ref: PlayerRef, value: number} = {ref: {} as PlayerRef, value: 0};
    private dataForPlayers: PlayerGlobalData[] = [];
    private sortKey: string = "playerRef.playerName";
    private sortKeyDirection: string = "asc";
    private seasonKey: string = "2024";

    public reset() {
        this.teams = [];
        this.matches = [];
        this.finalMatches = [];
        this.bestPlayer = {ref: {} as PlayerRef, value: 0};
        this.totalKills = {ref: {} as PlayerRef, value: 0};
        this.killStreak = {ref: {} as PlayerRef, value: 0};
        this.longestKill = {ref: {} as PlayerRef, value: 0};
        this.collateralKill = {ref: {} as PlayerRef, value: 0};
        this.teamKill = {ref: {} as PlayerRef, value: 0};
        this.defuser = {ref: {} as PlayerRef, value: 0};
        this.dataForPlayers = [];
    }

    public init() {
        const gameResults = this.dataService.retrieveChampionshipGames(this.seasonKey);
        this.$store.commit("championshipGamesRetrieved", gameResults);
        this.reset();
        for (let i = 0; i < this.calendarBySeason.length; i++) {
            this.matches.push(new ChampionshipMatch(this.calendarBySeason[i]));
        }
        for (let i = 0; i < this.finalFourBySeason.length; i++) {
            this.finalMatches.push(new FinalMatch(this.finalFourBySeason[i]));
        }
        for (let i = 0; i < this.teamsBySeason.length; i++) {
            this.teams.push(new ChampionshipTeam(this.teamsBySeason[i]));
        }
        this.teams.forEach((t) => {
            let mean = 0;
            t.members.forEach((m) => mean += this.matchMakingService.computeEMP(m.guid, this.games));
            t.emp = mean / 3;
        });

        this.computeResults();
        let refRatio1 =  -1;
        let refRatio2 =  -1;
        let refRatio3 =  -1;
        let refRatio4 =  -1;
        let refRatio5 =  -1;
        let refRatio6 =  -1;
        for (const gameResult of this.gameResults) {
            const totalScore = this.retrieveValue(gameResult, "totalScore");
            if (this.bestPlayer.value < totalScore.totalScore || (this.bestPlayer.value === totalScore.totalScore && totalScore.globalRatio > refRatio1)) {
                this.bestPlayer.value = totalScore.totalScore;
                this.bestPlayer.ref = totalScore.playerRef;
                refRatio1 = totalScore.globalRatio;
            }
            const totalKills = this.retrieveValue(gameResult, "totalKills");
            if (this.totalKills.value < totalKills.totalKills || (this.totalKills.value === totalKills.totalKills && totalKills.globalRatio > refRatio1)) {
                this.totalKills.value = totalKills.totalKills;
                this.totalKills.ref = totalKills.playerRef;
                refRatio1 = totalKills.globalRatio;
            }
            const killStreak = this.retrieveValue(gameResult, "killstreak");
            if (this.killStreak.value < killStreak.killstreak || (this.killStreak.value === killStreak.killstreak && killStreak.globalRatio > refRatio2)) {
                this.killStreak.value = killStreak.killstreak;
                this.killStreak.ref = killStreak.playerRef;
                refRatio2 = killStreak.globalRatio;
            }
            const longestKill = this.retrieveValue(gameResult, "longestKill");
            if (this.longestKill.value < longestKill.longestKill || (this.longestKill.value === longestKill.longestKill && longestKill.globalRatio > refRatio3)) {
                this.longestKill.value = longestKill.longestKill;
                this.longestKill.ref = longestKill.playerRef;
                refRatio3 = longestKill.globalRatio;
            }
            const collateral = this.retrieveValue(gameResult, "collateralKills");
            if (this.collateralKill.value < collateral.collateralKills || (this.collateralKill.value === collateral.collateralKills && collateral.globalRatio > refRatio4)) {
                this.collateralKill.value = collateral.collateralKills;
                this.collateralKill.ref = collateral.playerRef;
                refRatio4 = collateral.collateralKills;
            }
            const teamkiller = this.retrieveValue(gameResult, "teamKills");
            if (this.teamKill.value < teamkiller.teamKills || (this.teamKill.value === teamkiller.teamKills && teamkiller.globalRatio > refRatio5)) {
                this.teamKill.value = teamkiller.teamKills;
                this.teamKill.ref = teamkiller.playerRef;
                refRatio5 = teamkiller.teamKills;
            }
            const defuser = this.retrieveValue(gameResult, "bombsDefused");
            if (this.defuser.value < defuser.bombsDefused || (this.defuser.value === defuser.bombsDefused && defuser.globalRatio > refRatio6)) {
                this.defuser.value = defuser.bombsDefused;
                this.defuser.ref = defuser.playerRef;
                refRatio6 = defuser.bombsDefused;
            }
        }
        this.dataForPlayers = this.dataService.computePlayersPerformance(this.gameResults, false);
        this.dataForPlayers = orderBy(this.dataForPlayers, ["playerRef.playerName"], ["asc"]);
    }

    get winner(): string {
        if (this.seasonKey === "2020") {
            return "Les Sales gosses";
        }
        if (this.seasonKey === "2021") {
            return "Les pisseurs";
        }
        if (this.seasonKey === "2024") {
            return "Le Bon, La Brute et le Truand";
        }
        return "";
    }

    get calendarBySeason() {
        if (this.seasonKey === "2020") {
            return season1Calendar;
        }
        if (this.seasonKey === "2021") {
            return season2Calendar;
        }
        return season3Calendar;
    }

    get finalFourBySeason() {
        if (this.seasonKey === "2024") {
            return season3FinalFour;
        }
        return [];
    }

    get teamsBySeason() {
        if (this.seasonKey === "2020") {
            return season1Teams;
        }
        if (this.seasonKey === "2021") {
            return season2Teams;
        }
        return season3Teams;
    }

    get seasonName() {
        if (this.seasonKey === "2020") {
            return "season1";
        }
        if (this.seasonKey === "2021") {
            return "season2";
        }
        return "season3";
    }

    get teamsLadder(): ChampionshipTeam[] {
        return orderBy(this.teams, ["points", "name"], ["desc"]);
    }

    get nextMatches(): ChampionshipMatch[] {
        return this.matches.filter((m) => !m.played);
    }

    get playedMatches(): ChampionshipMatch[] {
        return this.matches.filter((m) => m.played).reverse();
    }

    get semiFinals(): FinalMatch[] {
        return this.finalMatches.filter((m) => !m.final && !m.smallFinal);
    }

    get final(): FinalMatch | null {
        const finals = this.finalMatches.filter((m) => m.final && !m.smallFinal)
        if (finals.length > 0) {
            return finals[0];
        } else {
            return null;
        }
    }

    get smallFinal(): FinalMatch | null {
        const smallFinals = this.finalMatches.filter((m) => !m.final && m.smallFinal)
        if (smallFinals.length > 0) {
            return smallFinals[0];
        } else {
            return null;
        }
    }

    public changeSort(key: string) {
        if (this.sortKey === key) {
            this.sortKeyDirection = this.sortKeyDirection === "desc" ? "asc" : "desc";
        } else {
            this.sortKeyDirection = "desc";
        }
        this.sortKey = key;
    }

    get sortedDataForPlayers(): PlayerGlobalData[] {
        // @ts-ignore
        return orderBy(this.dataForPlayers, [this.sortKey], this.sortKeyDirection);
    }

    public teamIcon(team: string): string {
        const images = require.context("../data/championship/", true, /\.png$/);
        return images("./" + this.seasonName + "/icons/" + team + ".png");
    }

    public teamMap(map: string): string {
        if (map.indexOf("http") === 0) {
            return map;
        }
        return "http://www.customapscod.com/images/maps/cod4/" + map + ".jpg";
    }

    public goToGame(matchId: string) {
        this.$router.push("/game/championship" + matchId);
    }

    public goToTournament(tournamentSeason: string) {
        this.seasonKey = tournamentSeason;
        this.init();
    }

    public matchPlayed(team: string): number {
        return this.matches.filter((m) => m.played && (m.team1 === team || m.team2 === team)).length;
    }

    private computeResults() {
        for (const gameResult of this.gameResults) {
            for (const gameRef of gameResult.gameRefs) {
                const refAllies = gameRef.players.filter((p) => p.team === "allies")[0];
                for (const team of this.teams) {
                    if (team.members.filter((m) => m.guid === refAllies.playerRef.guid).length > 0) {
                        team.points += gameRef.alliesScore;
                        if (gameRef.alliesScore === 5) {
                            team.points += 2;
                        }
                        break;
                    }
                }
                const refAxis = gameRef.players.filter((p) => p.team === "axis")[0];
                for (const team of this.teams) {
                    if (team.members.filter((m) => m.guid === refAxis.playerRef.guid).length > 0) {
                        team.points += gameRef.axisScore;
                        if (gameRef.axisScore === 5) {
                            team.points += 2;
                        }
                        break;
                    }
                }
            }
        }
    }

    private retrieveValue(game: Game, ref: string): Player {
        return orderBy(game.players, [ref], ["desc"])[0];
    }

}
